<template>
    <Layout :pagetitle="'裝置組別綁定'">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title mb-0">裝置組別綁定</h4>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12">
                            <div class="mt-4 mt-xl-0">
                                <h5 class="font-size-14 mb-4">
                                    <i class="mdi mdi-arrow-right text-primary me-1"></i>基本資訊
                                </h5>
                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="form-label" for="financial-groupCode">組別代碼</label>
                                        <div>
                                            <span>{{ form.groupCode }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label" for="financial-groupName">組別名稱</label>
                                        <div>
                                            <span>{{ form.groupName }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="mb-3">
                                            <label class="form-label" for="financial-description">描述</label>
                                            <div>
                                                <span>{{ form.description }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <h5 class="font-size-14 mb-4">
                                        <i class="mdi mdi-arrow-right text-primary me-1"></i>可綁定裝置清單
                                    </h5>
                                    <div class="row">
                                        <Grid :style="{ height: '100%' }"
                                              :data-items="ownGrid.result"
                                              :selected-field="ownGrid.selectedField"
                                              :sortable="true"
                                              :pageable="{ refresh: true, pageSizes: [10, 25, 50, 100], buttonCount: 5 }"
                                              :scrollable="'none'"
                                              :filterable="false"
                                              :filter="ownGrid.filter"
                                              :sort="ownGrid.sort"
                                              :skip="ownGrid.skip"
                                              :take="ownGrid.take"
                                              :total="ownGrid.total"
                                              :columns="columns"
                                              @selectionchange="onSelectionChange"
                                              @headerselectionchange="onHeaderSelectionChange"
                                              @rowclick="onRowClick"
                                              @pagechange="pageChangeHandler">
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="col-lg-12">
                            <div class="mt-4 mt-xl-0">
                                <div class="row d-flex justify-content-between">
                                    <div class="hstack gap-3">
                                        <button type="button" @click.prevent="back" :disabled="isCloseBtn"
                                                class="btn btn-primary">上一頁
                                        </button>
                                        <div class="vr"></div>
                                        <button type="submit" @click.prevent="assign" :disabled="isCloseBtn"
                                                class="btn btn-primary">
                                            確認綁定
                                        </button>
                                    </div>
                                    <div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import {useRoute, useRouter} from 'vue-router';
import Layout from "../../layouts/main";
import {ref, onMounted} from "vue";
import {Grid} from "@progress/kendo-vue-grid";
import {toDataSourceRequestString} from "@progress/kendo-data-query";
import axios from 'axios';
//import { backendAPI } from "../../../components/commons/axiosBackendApj";


const findGroup = async (groupCode) => {
    const quer_url = '/api/FindGroup'
    const init_data = {method: 'GET', accept: 'application/json', headers: {}};
    let group = await fetch(`${quer_url}?groupCode=${groupCode}`, init_data)
        .then(response => response.json());

    return {groupName: group.value.roleName, description: group.value.description}
}


const fetchData = async (dataState) => {
    const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state
    const base_url = "/api/QueryGroupUnOwnClient";
    const init = {method: "GET", accept: "application/json", headers: {}};
    let fetchResult = await fetch(`${base_url}?${queryStr}`, init)
        .then((response) => response.json())
        .then(({data, total}) => {
            let result = data.map((item) => {
                return {...item, selected: false};
            });
            return {result: result, total: total};
        });

    return fetchResult;
};


export default {

    setup() {

        const route = useRoute();
        const router = useRouter();
        const groupCode = route.params.id;

        const form = ref({
            groupCode: groupCode,
            groupName: "",
            description: ""
        });

        const ownGrid = ref({
            selectedField: "selected",
            sort: null,
            filter: {
                logic: "and",
                filters: [{
                    field: "groupCode",
                    operator: "eq",
                    value: groupCode,
                }],
            },
            result: [],
            skip: 0,
            take: 10,
            total: 0,
            staticColumns: [
                {field: "clientId", title: "代號"},
                {field: "clientName", title: "裝置名稱"},
            ],
            formSelected: [],
        });

        onMounted(async () => {

            let formData = await findGroup(groupCode);
            form.value.groupName = formData.groupName;
            form.value.description = formData.description;


            let dataState = {skip: ownGrid.value.skip, take: ownGrid.value.take, filter: ownGrid.value.filter};
            let fetchResult = await fetchData(dataState);

            ownGrid.value.result = fetchResult.result;
            ownGrid.value.total = fetchResult.total;

        });

        const isCloseBtn = ref(false);
        return {
            ownGrid,
            form,
            isCloseBtn,
            router
        };
    },
    components: {
        Layout,
        Grid,

    },
    computed: {
        areAllSelected() {
            return this.ownGrid.result.findIndex((item) => item.selected === false) === -1;
        },
        columns() {
            return [
                {
                    field: "selected",
                    width: "50px",
                    headerSelectionValue: this.areAllSelected,
                },
                ...this.ownGrid.staticColumns,
            ];
        },
    },
    methods: {
        fetchData: async function (dataState) {
            let data = await fetchData(dataState);
            this.ownGrid.result = data.result;
            this.ownGrid.total = data.total;
        },
        pageChangeHandler: function (event) {
            setTimeout(() => {
                this.ownGrid.skip = event.page.skip;
                this.ownGrid.take = event.page.take;
                this.fetchData({skip: this.ownGrid.skip, take: this.ownGrid.take, filter: this.ownGrid.filter});
            }, 300);
        },
        onHeaderSelectionChange(event) {
            let checked = event.event.target.checked;
            this.ownGrid.result = this.ownGrid.result.map((item) => {
                return {...item, selected: checked};
            });
            this.ownGrid.result.forEach((element) => {
                this.changeApplyFormSelected(element.userCode, element.selected);
            });
        },
        onSelectionChange(event) {
            event.dataItem[this.ownGrid.selectedField] = !event.dataItem[this.ownGrid.selectedField];
            let clientId = event.dataItem["clientId"];
            this.changeApplyFormSelected(clientId, event.dataItem[this.ownGrid.selectedField]);
        },
        onRowClick(event) {
            event.dataItem[this.ownGrid.selectedField] = !event.dataItem[this.ownGrid.selectedField];
            let clientId = event.dataItem["clientId"];
            this.changeApplyFormSelected(clientId, event.dataItem[this.ownGrid.selectedField]);
        },
        changeApplyFormSelected(clientId, isSelected) {
            if (isSelected) {
                if (!this.ownGrid.formSelected.includes(clientId)) {
                    this.ownGrid.formSelected.push(clientId);
                }
            } else {
                if (this.ownGrid.formSelected.includes(clientId)) {
                    this.ownGrid.formSelected = this.ownGrid.formSelected.filter((x) => x != clientId);
                }
            }
        },
        assign() {

            let form = {
                ClientIds: this.ownGrid.formSelected,
                GroupCode: this.form.groupCode
            };
            axios({
                method: "post",
                url: "/api/AssignClient",
                headers: {
                    "content-type": "application/json",
                },
                data: form,
            })
                .then((response) => {
                    console.log(response);
                    this.fetchData({skip: this.ownGrid.skip, take: this.ownGrid.take, filter: this.ownGrid.filter});
                })
                .catch((error) => {
                    console.log(error);
                    this.fetchData({skip: this.ownGrid.skip, take: this.ownGrid.take, filter: this.ownGrid.filter});
                });
            this.ownGrid.formSelected = [];
        },
        back() {
            let groupCode = this.form.groupCode;
            this.router.push({name: 'group-own-client', params: {id: groupCode}});
        }
    },
};
</script>
